// AI RCA analytics event names, fired via the onEvent(name, params) prop.
export const RCA_EVENTS = {
  TRIGGER_SHOWN: 'airca_trigger_shown',
  TRIGGER_CLICKED: 'airca_trigger_clicked',
  DRAWER_OPENED: 'airca_drawer_opened',
  GENERATION_REQUESTED: 'airca_generation_requested',
  GENERATION_SUCCEEDED: 'airca_generation_succeeded',
  GENERATION_FAILED: 'airca_generation_failed',
  POLLING_TIMEOUT: 'airca_polling_timeout',
  CREDIT_INSUFFICIENT: 'airca_credit_insufficient',
  FEEDBACK_RATING: 'airca_feedback_rating',
  SUGGESTION_SUBMITTED: 'airca_suggestion_submitted',
  RETRY_CLICKED: 'airca_retry_clicked',
  TIMELINE_STEP_EXPANDED: 'airca_timeline_step_expanded',
  DRAWER_CLOSED: 'airca_drawer_closed',
};
